import { IconButton, Input, } from 'native-base';
import React, { FunctionComponent, useCallback, useMemo } from 'react';
import { Ionicons, MaterialCommunityIcons } from "@expo/vector-icons";
import { ElementBase, IElementBaseProps, ModalFull, initializeElement } from '..';
import { RNPicker } from "../base/RNPicker";

import { getDataFromIntegration, getDisplayAndValue } from '../../utils/itemCommonFunctions';
import { TextInput } from 'react-native-gesture-handler';

import { onPatch } from 'mobx-state-tree';
import { conditionIsGo } from '../../utils/conditionIsGo';
import { useDebouncedCallback } from 'use-debounce';
import { glueStyles } from '../../../app/configGlueStack/gluestack-ui.config';

import { Button, ButtonIcon, Icon, ButtonText, CheckIcon, HStack, VStack, Spinner, } from "@gluestack-ui/themed"
import Spacer from '../base/Spacer';
import {
    View,
    Text,
    Pressable,
    StyleSheet,
    FlatList
} from 'react-native';


const OptionItem = React.memo(({ opt, selected, isButton, onPress }: any) => {
    const { display } = getDisplayAndValue(opt);
    
    if (isButton) {
        return (
            <Pressable
                onPress={() => onPress(opt)}
                style={[styles.buttonOpt, selected && styles.buttonOptSelected]}
            >
                <Text style={[styles.buttonOptText, selected && styles.buttonOptTextSelected]}>
                    {display.toUpperCase()}
                </Text>
            </Pressable>
        );
    }
    return (
        <Pressable onPress={() => onPress(opt)} style={styles.checkRow}>
            <Icon
                as={Ionicons}
                name={selected ? "checkbox-outline" : "square-outline"}
                size="lg"
                color={selected ? glueStyles.colors.primary400 : glueStyles.colors.textLight400}
            />
            <Text style={styles.checkText}>{display}</Text>
        </Pressable>
    );
});

export const MultipleElement: FunctionComponent<IElementBaseProps> = ({ ...props }) => {
    const fcName = "MultipleElement";
    const {
        itemsStore, integrationsStore, element, statusStore, checkAndSetPayload,
        payload, setPayload,
        errorList,
        modalVisible, setModalVisible
    } = initializeElement(props);

    const asSelect = (element.type === 'select' || element.type === 'sendemail1')
    const [options, setOptions] = React.useState<string[]>((element.integration?.id == undefined && element.isDinamic == false) ? element.templateData.options : []);

    const [loadingOptions, setLoadingOptions] = React.useState<boolean>(false);
    const [filterActived, setFilterActived] = React.useState<string>("");

    const handlePressed = useCallback((val: string | string[] | undefined) => {
        try {
            if (props.forReview || payload.readOnly) return;
            if (!element.templateData.onlyOne && !asSelect) {
                const pay = Array.isArray(payload.value) ? payload.value.slice() : [];
                if (pay.includes(val)) pay.splice(pay.indexOf(val), 1);
                else if (val?.toString().substring(0, 6) === "OTHER|" && pay.find(v => v.substr(0, 6) === val?.toString().substring(0, 6)))
                    pay.splice(pay.findIndex(v => v.substr(0, 6) === val?.toString().substring(0, 6)), 1);
                else
                    pay.push(val);
                val = pay;
            } else if (element.templateData.optionsAsButtons && payload.value == val) {
                val = undefined;
            } else if ((asSelect || element.templateData.onlyOne) && val && val.toString().includes("}|")) {
                const objVal = getDisplayAndValue(val.toString());
                checkAndSetPayload(objVal.label, undefined, { ...payload, value: objVal.label, url: objVal.url })
                return;
            }
            checkAndSetPayload(val, undefined, { ...payload, value: val, url: null });
        } catch (e) { console.error(e) }
    }, [props.forReview, payload, checkAndSetPayload]);

    const isSelectedOther = (): boolean => {
        if (payload.value == undefined)
            return false;
        if (Array.isArray(payload.value))
            return payload.value.reduce((hasOther, itemSelected) => hasOther || itemSelected.toString().substring(0, 6) == "OTHER|", false);
        console.log("payload.value", payload.value)
        return payload.value.toString().substring(0, 6) == "OTHER|"
    };

    const handleTextOther = (val: string) => {
        val = val || "";
        let value;
        if (Array.isArray(payload.value))
            value = payload.value.map((itemSelected) => {
                return itemSelected.substring(0, 6).toUpperCase() == "OTHER|" ? "OTHER|##".concat(val || "").concat("##") : itemSelected
            });
        else
            value = payload.value.substring(0, 6).toUpperCase() == "OTHER|" ? "OTHER|##".concat(val.concat("##"))
                : payload.value;
        setPayload({ ...payload, value });
    }

    const textOtherDisplay = () => {
        let val = Array.isArray(payload.value) ? payload.value : [payload.value];
        return val.reduce((text, itemSelected, idx) => {
            if (text != "")
                return text;
            if (itemSelected.substring(0, 8).toUpperCase() == "OTHER|##")
                return itemSelected.substring(8, itemSelected.length - 2);
            if (itemSelected.substring(0, 6).toUpperCase() == "OTHER|")
                text = "";
            return text;
        }, "");

    }

    const displayPayload = (): string => {
        if (payload.value == undefined)
            return "";
        if (Array.isArray(payload.value))
            return payload.value.reduce((valueString, itemSelected) => valueString.concat(getDisplayAndValue(itemSelected).display).concat(", "), "");
        return getDisplayAndValue(payload.value.toString()).display;

    };

    const setDefaultValue = () => {
        let _data = options;
        if (!payload.value || (Array.isArray(payload.value) && payload.value.length == 0))
            _data.map(item => {
                if (getDisplayAndValue(item).default)
                    setTimeout(() => handlePressed(item), 125);

            });
    }

    const putOptions = (data: string[]) => {
        
        setOptions(element.templateData.sort ? [].concat(data).sort() : data);
    }

    const reloadOptions = async () => {
        console.log(fcName, "reloadOptions", "IN", element.name)
        let payload = itemsStore.getPayloadElement(element.id, props.parentId, props.recordIdx);
        if (props.forReview || loadingOptions)
            return;
        const { id, templateData, integration, name, label } = element;

        let opts: any = [];
        if (integration?.id) {
            setLoadingOptions(true);
            opts = await getDataFromIntegration(element, itemsStore.getPayloadElement, props.parentId, props.recordIdx,
                integrationsStore.getIntegration);
            setLoadingOptions(false);
        } else if (element.isDinamic && templateData.dynamicOptions?.length > 0) {
            opts = conditionIsGo(element.templateData.dynamicOptions, itemsStore.itemActive.toJSON(), props.parentId, props.recordIdx);
            opts = opts.map((opt:string)=>itemsStore.loadConstValues(element,opt));
        } else
            opts = element.templateData.options.map((opt:string)=>itemsStore.loadConstValues(element,opt));
        if (!Array.isArray(opts))
            opts = [];
        putOptions(opts);

        if (Array.isArray(payload.value)) {
            let mustClean = false;
            payload.value.forEach(value => {
                if (value && !(opts.includes(value) || value.includes("OTHER|##")))
                    mustClean = true;
            })
            if (mustClean)
                handlePressed(null);

        } else {
            if (payload.value && !(opts.find((opt: string) => getDisplayAndValue(opt).label == payload.value) || payload.value.toString().includes("OTHER|##")))
                handlePressed(null);
        }
        console.log(fcName, "reloadOptions", "FIN", element.name)
    }

    const reloadOptionsDebouneced = useDebouncedCallback(reloadOptions, 250);

    React.useEffect(() => {
        try {
            if(props.forReview)
                return;
            options.length == 0 && !element.integration?.userMode && reloadOptions();
            let _disposerOnPatch = onPatch(itemsStore, patch => {
                let mustReloadOptions = false;
                if (element.integration && element.integration.userMode != true && element.integration.dynamicParams) {
                    Object.keys(element.integration.dynamicParams).forEach((v: any) => {
                        let myDependency = element.integration?.dynamicParams[v];
                        if (myDependency != element.id && patch.path.includes(myDependency))
                            mustReloadOptions = true;
                    });
                }
                if (element.isDinamic && element.templateData.dynamicOptions) {
                    element.templateData.dynamicOptions
                        .forEach(dynamicOption => {
                            if (dynamicOption.conditions)
                                dynamicOption.conditions.forEach(condition => {
                                    if (JSON.stringify(condition).includes(patch.path.split("/").slice(-2, -1).toString()))
                                        mustReloadOptions = true;
                                });
                            if (dynamicOption.filterOptions)
                                dynamicOption.filterOptions.forEach(filterOptions => {
                                    if (JSON.stringify(filterOptions).includes(patch.path.split("/").slice(-2, -1).toString()))
                                        mustReloadOptions = true;
                                });
                        });
                }
                if (mustReloadOptions) {
                    console.log("MultipleElement", element.name, "onPatch", "MustReloadOptions=true")
                    reloadOptionsDebouneced();
                    setFilterActived("");
                }
            });
        

            return () => {
                _disposerOnPatch();
                _disposerOnPatch = undefined;
            }
        } catch (e) { }
    }, [undefined, props.forReview]);

    const showSelect = () => {
        let _options = Array.isArray(options) ? options : [];
        return <RNPicker testID="rnpicker-MultipleEl" disablePicker={_options.length == 0 || loadingOptions}
            data={[{ id: "-1", name: "" }].concat((_options || [])?.map((item, idx) => ({ id: idx.toString(), name: getDisplayAndValue(item).display, item })))}
            defaultValue={true}
            showSearchBar={(_options || []).length > 10} searchBarPlaceHolder={"Buscar....."}
            selectedText={payload.value ? getDisplayAndValue(payload.value.toString()).display : undefined}
            selectedValue={(index: number, item: { id: string, name: string, item: string }) => handlePressed(item.item)}
            style={{width:"100%"}}
        />
    }

    const isOptionSelected = useCallback((option): boolean => {
            if (payload?.value === undefined)
                return false;
            if (payload && Array.isArray(payload?.value))
                return payload.value.includes(option) || (option.startsWith("OTHER|") && payload?.value?.some(v => v.startsWith("OTHER|")));
            return payload?.value === option || (option.startsWith("OTHER|") && payload?.value?.toString().startsWith("OTHER|"));
        }, [payload.value]);

    const renderNoModal = () => {
        return (asSelect && !element.templateData.optionsAsButtons ?
            showSelect() :
            <View style={[
                element.templateData.optionsAsButtons ? styles.wrapRow : styles.fullCol,
                { width: '100%', marginTop: 10 }
            ]}>
                {filteredOptions.map((opt, idx) => (
                    <OptionItem 
                        key={`opt-nomodal-${idx}`} // Key única
                        opt={opt}
                        selected={isOptionSelected(opt)}
                        isButton={element.templateData.optionsAsButtons}
                        onPress={handlePressed}
                    />
                ))}
            </View>)
    }

    const getRender = () => {
        return <ElementBase errors={errorList} element={element} forReview={props.forReview} rightButton={btnCallIntegration}
            link={payload.url} changedMe={{ value: payload.value, options }}>
            {!props.forReview ?
                <>
                    {(element.templateData.noModal && options?.length < 20) || asSelect ?
                        renderNoModal()
                        :
                        <>
                            <HStack>
                                <Input isReadOnly
                                    style={{ color: (element.templateData.textColor || "#000") }}
                                    placeholder={element.templateData.placeholder || ""}
                                    value={displayPayload()}
                                    width="60%"
                                    borderWidth="0" size="md"
                                   
                                />
                                <Spacer></Spacer>
        <IconButton onPress={() => { setModalVisible(!modalVisible) }} icon={<Icon as={MaterialCommunityIcons} color='$primary400' name="checkbox-multiple-marked" size="xl" />} />
            
                            </HStack>

                        </>
                    }
                    {isSelectedOther() ?
                        <Input keyboardType={"default"} style={{ color: (element.templateData.textColor || "#000") }} onChangeText={handleTextOther}
                            value={textOtherDisplay() || ""}
                            placeholder={"Escriba aqui otra Opcion"}
                            size={"md"}
                        />
                        : null}
                </>
                :
                <Text
                    style={{
                        color: element.templateData?.textColor || "#000"
                    }}>{displayPayload()}</Text>
            }
        </ElementBase>
    }

    React.useEffect(() => {
        try {
            !(payload.value == null && options.length == 0) && setDefaultValue()
        } catch (e) { }
        //setRender(getRender())
    }, [options, payload, modalVisible])

    let btnCallIntegration = loadingOptions ? <Spinner size="small" /> : <></>;
    if (!props.forReview && !loadingOptions && element.integration && element.integration.id && element.integration.userMode)
        btnCallIntegration = (<Button borderRadius={0} width={55} height={55} p="$1" bgColor={"$white"}
            variant="solid"
            key="btnImportIntegration" size="lg"
            onPress={reloadOptions}
        ><ButtonIcon as={Ionicons} name="sync-circle" fontWeight="$extrabold" size="xl" color="$primary400" />
        </Button>)

    // Filtrado memorizado
    const filteredOptions = useMemo(() => {
        return (options || []).filter((opt) => 
            getDisplayAndValue(opt).display.toLowerCase().includes(filterActived.toLowerCase())
        );
    }, [options, filterActived]);

    const renderOption = ({ item }: any) => (
        <OptionItem 
            opt={item} 
            selected={isOptionSelected(item)} 
            isButton={element.templateData.optionsAsButtons}
            onPress={handlePressed}
        />
    );

    return <>
        {getRender()}
        {modalVisible &&
            <ModalFull
                visible={modalVisible}
                title="Elija las opciones"
                closeButton_onPress={() => { setModalVisible(false); setFilterActived(""); }}
                footer={<>
                    <Button width={"100%"} size="md" variant="solid" action="primary"
                        borderRadius={0}
                        onPress={() => { setModalVisible(false); setFilterActived(""); }}>
                        <ButtonIcon size='md' as={CheckIcon} />
                        <ButtonText>Aceptar</ButtonText>
                    </Button>
                </>
                }><View style={styles.modalContent}>
                        {options.length < 20 ? <></>
                            :
                            <TextInput underlineColorAndroid={"transparent"}
                                placeholder={"Buscar..."}
                                onChangeText={setFilterActived}
                                returnKeyType={"done"}
                                blurOnSubmit={true}
                                style={styles.searchInput}
                            />
                        }
                    <FlatList style={{ width: '100%' }}
                            data={filteredOptions}
                            renderItem={renderOption}
                            keyExtractor={(item, index) => index.toString()}
                            initialNumToRender={10}
                            maxToRenderPerBatch={10}
                            windowSize={5}
                        />
                    </View>
            </ModalFull>
        }
    </>;
}

const styles = StyleSheet.create({
    container: { width: '100%', paddingVertical: 5 },
    wrapRow: { flexDirection: 'row', flexWrap: 'wrap' },
    fullCol: { flexDirection: 'column' },
    inputLike: {
        flexDirection: 'row',
        alignItems: 'center',
        borderWidth: 1,
        borderColor: '#ddd',
        borderRadius: 5,
        padding: 10,
        minHeight: 50
    },
    inputText: { flex: 1, color: '#333' },
    reviewText: { padding: 5, fontSize: glueStyles.fontSizes.sm, color: '#555' },
    buttonOpt: {

        maxWidth:"100%",
        margin: '0.5%',
        paddingVertical: 8,
        paddingHorizontal: 8,
        borderWidth: 1,
        borderColor: glueStyles.colors.primary400, // primary400
        borderRadius: 6,
        alignItems: 'center',
        backgroundColor: '#fff'
    },
    buttonOptSelected: { backgroundColor: glueStyles.colors.primary400 },
    buttonOptText: {
        color: glueStyles.colors.primary400, fontWeight: '600', fontSize: glueStyles.fontSizes.xs, paddingHorizontal: 5
    },
    buttonOptTextSelected: { color: '#fff' },
    checkRow: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 12,
        paddingHorizontal: 10,
        borderBottomWidth: 0.5,
        borderBottomColor: '#eee'
    },
    checkText: { marginLeft: 10, flex: 1, color: '#333' },
    modalContent: { flex: 1, backgroundColor: '#fff', padding: 10,width:"98%" },
    searchInput: {
        height: 45,
        borderWidth: 1,
        borderColor: '#ccc',
        borderRadius: 8,
        paddingHorizontal: 15,
        marginBottom: 10,
        backgroundColor: '#f9f9f9'
    }
});